import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../../../../assets/color';
import { useSearchParams } from 'react-router-dom';
import RouteHeader from '../../../../../../components/common/RouteHeader';
import DatatableHeading from '../../../../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../../../../components/datatable/DatatableWithSearch';
import * as AdminActions from '../../../../../../redux/actions/adminAction';

const AffiliateCustomers = () => {
    const dispatch = useDispatch();
    const [searchParam] = useSearchParams();
    const affiliateId = searchParam.get('id') || '';
    const affiliate_name = searchParam.get('name') || '';
    const { customersByAffiliateIdData } = useSelector(state => state?.adminReducer);
    const columns = [
        { name: 'S.No.', selector: row => customersByAffiliateIdData?.indexOf(row) + 1, width: '80px' },
        { name: 'Customer Name', selector: row => row?.full_name || '—' },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Gender', selector: row => row?.gender || '...' },
        { name: 'City', selector: row => row?.city || '...' },
        { name: 'Country', selector: row => row?.country || '...' },
        { name: 'Report Type', selector: row => row?.report_type || '—', width: '200px' },
        { name: 'Report Generated', selector: row => row?.report_generated ? 'Yes' : 'No' },
        { name: 'Date', selector: row => row?.createdAt ? moment(row.createdAt).format('DD MMM YYYY') : '—' },
    ];
    useEffect(() => {
        dispatch(AdminActions.getCustomersByAffiliateId({ affiliateId }));
    }, []);
    return (
        <>
            <RouteHeader title={`${affiliate_name} – Customers`} sub_title="View customers under this affiliate" />
            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={`Customers under ${affiliate_name}`} />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={customersByAffiliateIdData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    );
};
export default AffiliateCustomers;
